var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 633.55 300",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #0054a4;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 163.59,
  width: 200,
  height: 200
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "296.26 111.1 633.55 40.79 297.12 78.85 331.89 19.83 275.84 68.65 263.73 3.62 251.63 72.9 195.6 43.86 231.15 91.4 0 153.6 231.47 122.18 195.6 180.16 251.97 133.22 263.73 196.38 275.59 128.5 331.89 156.13 296.26 111.1"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.fe4d392a.svg";
export { ForwardRef as ReactComponent };